import React from 'react';
import { useSelector } from 'react-redux';
import styles from './accordion.module.css';
// import { Element, scroller } from 'react-scroll';
import { ChevronDown } from 'react-feather';
import { useViewport } from '../../../utils';
import Element from 'react-scroll/modules/components/Element';
import scroller from 'react-scroll/modules/mixins/scroller';

const AccordionItem = ({data = {}, onClick, isSelected}) => {
  const { isMobile } = useViewport()
  const language = useSelector(state => state.system.language)
  const {
    id,
    title = "",
    content = {en: "", id: ""}
  } = data

  const handleClick = (target) => {
    setTimeout(() => {
      scroller.scrollTo(target, {
        duration: 500,
        smooth: true,
        offset: isMobile ? -85 : -85
      })
    }, 500)
  }

  return (
    <Element name={`accordionItem${id}`} className={styles['accordion-item']}>
      <div onClick={() => handleClick(`accordionItem${id}`)}>
        <div className="cursor-pointer py-5 lg:py-10 flex items-center justify-between" onClick={onClick}>
          <div className="text-2xl font-bold pr-4 lg:pr-8">
            {title}
          </div>
          <ChevronDown className={`text-primary transition-transform duration-100 ${isSelected ? 'transform rotate-180' : ''}`}/>
        </div>
      </div>
      <div className={styles['accordion-content-formatter']}>
        <div className={isSelected ? styles['accordion-item__content--active'] : styles['accordion-item__content']}>
          <div className="prose" dangerouslySetInnerHTML={{__html: content[language.name]}}></div>
        </div>
      </div>
      <hr />
    </Element>
  )
}

export default AccordionItem
